export class ListTableMaintenanceRunsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "runType",
            "baseName": "runType",
            "type": "MaintenanceRunType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListTableMaintenanceRunsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
